export const config = {
    defaults: {},
    variations: {},
};
